import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import Enum from '@square/dashboard-utilities/utils/enum';
import Error from '@square/dashboard-data/models/squareup/rolodex/error';
import { RequestType, FlowType } from '@square/dashboard-data/models/squareup/rolodex/privacy-log';
export const DEFAULT_LIMIT = 100;
export const Code = new Enum(['SUCCESS', 'FAILURE', 'INVALID_EMAIL', 'INVALID_PHONE', 'INVALID_TEXT']);

// Privacy request
export const CreateContactPrivacyRequestRequest = ProtoBaseModel.extend({
  merchantToken: attr(String),
  contactToken: attr(String),
  requestType: attr(RequestType),
  flowType: attr(FlowType)
});
export const CreateContactPrivacyRequestResponse = ProtoBaseModel.extend({
  error: attr(Error)
});

// Message unit
export const CreateMessageUnitRequest = ProtoBaseModel.extend({
  merchantToken: attr(String),
  messageId: attr(String),
  idempotenceKeySuffix: attr(String)
});
export const CreateMessageUnitResponse = ProtoBaseModel.extend({
  error: attr(Error)
});